import { Button } from '@sgme/ui';
import classNames from 'classnames';
import { ReactNode } from 'react';

export type PromoteCardProps = {
  className?: string;
  title: string;
  subTitle?: string;
  variant?: 'default' | 'large';
  icon?: ReactNode;
  action?: ReactNode;
  onClose: () => void;
};

export function PromoteCard({
  title,
  subTitle,
  variant = 'default',
  icon,
  action,
  className,
  onClose,
}: PromoteCardProps) {
  const isDefaultVariant = variant === 'default';

  return (
    <div
      className={classNames(
        'position-relative border border-info  d-flex ',
        {
          'flex-column': !isDefaultVariant,
          'flex-row flex-wrap justify-content-between': isDefaultVariant,
        },
        className,
      )}
    >
      <div className="d-flex gap-3 pe-2">
        <div className="flex-grow-1 d-flex align-items-center gap-3 pt-3 pb-3 ps-3 text-info">
          {Boolean(icon) && icon}
          <div
            className={classNames('d-flex flex-column lh-sm fs-14 fw-medium', {
              'fs-16': !isDefaultVariant,
            })}
          >
            <span>{title}</span>
            {Boolean(subTitle) && <span className="text-secondary">{subTitle}</span>}
          </div>
        </div>

        {!isDefaultVariant && (
          <Button purpose="flat" iconPosition="icon-only" color="secondary" className="mt-2 " onClick={onClose}>
            <i className="icon">close</i>
          </Button>
        )}
      </div>

      <div
        className={classNames('d-flex justify-content-end flex-grow-1 gap-3', {
          'p-3': !isDefaultVariant,
          'align-items-center': isDefaultVariant,
        })}
      >
        {Boolean(action) && (
          <div className="d-flex flex-row item align-items-center gap-2 text-info fs-14 fw-medium lh-sm">{action}</div>
        )}

        {isDefaultVariant && (
          <Button purpose="flat" iconPosition="icon-only" color="secondary" className={'me-2'} onClick={onClose}>
            <i className="icon">close</i>
          </Button>
        )}
      </div>
    </div>
  );
}
